module.exports = __webpack_public_path__ + "img/icon_check.47ddc03.svg";